<template>
	<el-dialog
		title="自动回复"
		:visible.sync="dialogVisibe"
		width="660px"
		height="400px"
		:custom-class="classNames + '_dialog'"
		key="replyDialog"
		:close-on-press-escape="false"
		:close-on-click-modal="false"
		@close="cardBtnCancel">
			<div class="card-control-form">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="right" label-width="150px">
					<el-form-item label="规则名称:" prop="name">
						<el-input v-model="ruleForm.name" placeholder="请输入规则名称" maxlength="30" show-word-limit class="el-item-custom-w320"></el-input>
					</el-form-item>
					<el-form-item label="触达条件:" prop="condition_type">
						<el-radio-group v-model="ruleForm.condition_type">
							<el-radio  v-for="item in conditionTypeList" :label="item.value" :key="item.value">{{item.label}}</el-radio>
						</el-radio-group>
					</el-form-item>
					
					<template v-if="ruleForm.condition_type == 1">
					<el-form-item label="关键词:" 
					:prop="'keywords.'+ index + '.key' " :rules="rules.key"
					 v-for="(items, index) of ruleForm.keywords" :key="index">
							<div :class="classNames+'_keyword-item'">
								<el-select v-model="items.key_rule" style="width: 100px; margin-right: 20px;">
									<el-option v-for="(item, idx) in conditionWordList" :label="item.label"
										:value="item.value" :key="idx"></el-option>
								</el-select>
								<el-input v-model="items.key" placeholder="请输入关键词名称" maxlength="30" show-word-limit style="width: 200px;"></el-input>
								<i class="el-icon-remove-outline icon-custom-auto" @click="delRuleConditionFun(items,index)" v-if="index > 0"></i><i class="el-icon-circle-plus-outline icon-custom-auto" @click="addRuleConditionFun(items,index)" v-if="index < 4"></i>
							 </div>
						
					</el-form-item>
					 </template>
					
					<el-form-item label="触发条件:" v-if="ruleForm.condition_type == 2">
						<el-select v-model="ruleForm.condition_value">
							<el-option v-for="(item, idx) in conditionValueList" :label="item.label"
								:value="item.value" :key="idx"></el-option>
						</el-select>
						
					</el-form-item>
					
					<el-form-item label="回复类型:" prop="reply_type">
						<el-radio-group v-model="ruleForm.reply_type">
							<el-radio  v-for="item in replyTypeList" :label="item.value" :key="item.value">{{item.label}}</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="文字内容:" prop="content" v-if="ruleForm.reply_type == 1">
						<el-input  type="textarea" :rows="6" v-model="ruleForm.content" placeholder="请输入文字内容" maxlength="100" show-word-limit class="el-item-custom-w320"></el-input>
					</el-form-item>
					<el-form-item label="选择卡片:" prop="card_id" v-if="ruleForm.reply_type == 2">
					   <markerCard :data="ruleForm" :listData="cardListData" :search="searchObj" @getCardId="getCardId" @getCardList="getCardList">
					   </markerCard>
					</el-form-item>
				 </el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cardBtnCancel()">取 消</el-button>
				<el-button type="primary" @click="cardBtnSure()">确 定</el-button>
			</span>
	</el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import markerCard from './components/card.vue'
export default {
	props: {
		value: {
		    type: Boolean,
		    default: false
		},
		replyFormInfo: {
		    type: Object,
			default: () => ({
				id: '',
				name: "",
				condition_type: 1,
				keywords: [],
				condition_value: 1,
				reply_type: 1,
				content: "",
				card_id:  ''
			})
		},
	},
	components: {
		markerCard
	},
	data() {
		return {
            classNames: "autoReplyDialog",
			rules: {
				name: [
			        { required: true, message: '请输入规则名称', trigger: 'blur' },
			    ],
				condition_type: [
				    { required: true, message: '请选择触达条件', trigger: 'change' }
				],
				reply_type: [
				    { required: true, message: '请选择回复类型', trigger: 'change' }
				],
				content: [
				    { required: true, message: '请输入文字内容', trigger: 'blur' },
				],
				key: [
				    {
				        required: true,
				        trigger: 'blur',
				        validator: (rule, value, callback) => {
							console.log(rule, value);
				            if(value === '') {
				                callback(new Error('请输入关键词名称'))
				            } else {
				                callback()
				            }
				        },
				        // message: '请输入规格名称',
				    }
				],
				card_id: [
				    { required: true, message: '请选择卡片', trigger: 'change' }
				],
			},
			conditionTypeList: [
			    {
			        label: '关键词',
			        value: 1
			    },
			    {
			        label: '选择触发条件',
			        value: 2
			    }
			],
			replyTypeList: [
			    {
			        label: '文字',
			        value: 1
			    },
			    {
			        label: '卡片',
			        value: 2
			    }
			],
			conditionWordList: [
			    {
			        label: '包含',
			        value: 1
			    },
			    {
			        label: '全匹配',
			        value: 2
			    }
			],
			conditionValueList: [
				{
				    label: '用户第一次主动私信',
				    value: 1
				},
				{
				    label: '用户10分钟无回应',
				    value: 2
				},
				{
				    label: '用户1小时无回应',
				    value: 3
				},
			    {
			        label: '用户12小时无回应',
			        value: 4
			    }
			],
			searchObj: {
				page: 1,
				limit: 10,
				audit_status: 2,
				title: ''
			},
			cardListData: {
				total: 0,
				data: []
			}
		}
	},
	computed: {
		dialogVisibe: {
			get() {
				return this.value
			},
			set(news) {
				this.$emit("input",news);
			}
		},
		ruleForm: {
			get() {
				return this.replyFormInfo
			},
			set(news) {
				// this.ruleForm = news
			}
		}
	},
	watch: {
	    'ruleForm.condition_type': {
	        immediate: true,
	        handler(news) {
				if(this.ruleForm.condition_type == 1) {
					this.ruleForm.condition_value = 0
				} else {
					this.ruleForm.condition_value = 1
				}
	        }
	    },
	},
	created() {
		this.getCardsList()
	},
	methods: {
		...mapActions('dymessage', ['autoAddoredit','cardsList']),
		async getCardsList() {
			const params = {
				page: this.searchObj.page,
				limit: this.searchObj.limit,
				title: this.searchObj.title,
				audit_status: this.searchObj.audit_status
			}
			let res = await this.cardsList(params)
			this.cardListData = {
				total: res.count,
				data: res.list
			}
		},
		cardBtnSure(){
			this.$refs.ruleForm.validate(async (valid) => {
				if(valid) {
					try {
						const paramsData = {
							id: this.ruleForm.id,
							name: this.ruleForm.name, 
							condition_type: this.ruleForm.condition_type, 
							keywords: this.ruleForm.keywords,
							condition_value: this.ruleForm.condition_value, 
							reply_type: this.ruleForm.reply_type, 
							content: this.ruleForm.content, 
							card_id: this.ruleForm.card_id, 
						}
						if(paramsData.condition_type == 1){
							paramsData.condition_value = 0
						} else {
							paramsData.keywords = []
						}
						if(paramsData.reply_type == 1){
							paramsData.card_id = '' 
						} else {
							paramsData.content = ''
						}
						await this.autoAddoredit(paramsData)
						this.$emit('replyList')
						this.resetFormInfo()
					} catch (error) {
						this.$message({
						    type: 'error',
						    message:'操作失败',
						    duration: 3000
						})
					}
				}
			})
		},
		cardBtnCancel(){
			this.dialogVisibe = false
		},
		resetFormInfo(){
			this.dialogVisibe = false
		},
		addRuleConditionFun(data,idx){
			if(this.ruleForm.keywords.length < 5){
				this.ruleForm.keywords.push({key_rule: 1,key:''})	
			}else {
				this.$message({
					type: 'error',
					message:'最多可添加5组关键词',
					duration: 3000
				})	
			}
		},
		delRuleConditionFun(data,idx){
			console.log(data,idx)
			const index = this.ruleForm.keywords.indexOf(data)
			if (index !== -1) {
			  this.ruleForm.keywords.splice(index, 1)
			}
		},
		getCardId(data){
			this.ruleForm.card_id = data
		},
		getCardList(data){
			this.searchObj.page = data
			this.getCardsList()
		}
	}
}
</script>
<style lang="less">
    .replyDialog_dialog {
        .el-dialog__body {
            padding: 12px 20px;
        }
		.el-dialog__footer{
			text-align: center;
		}
    }
</style>
<style lang="less">
    @classNames: autoReplyDialog;
		 .@{classNames}_keyword-item{
			margin-bottom: 0px;
		 }
		.el-item-custom-w320{
			width: 320px;
		}
		 .icon-custom-auto{
			font-size: 24px;
			 margin-left: 10px;
			 vertical-align: -4px;
			 cursor: pointer;
		 }
		 
		 .@{classNames}_text_color {
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
		 }
</style>

 